import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";
import { getOrder } from "@store/Services/OrderService"; // Poolcorp Custom Code

replaceInChain(chain, RequestDataFromApi, async props => {
    try {
        props.apiResult = await getOrder(props.apiParameter); // Poolcorp Custom Import
    } catch (error) {
        if ("status" in error && error.status === 404) {
            props.dispatch({
                type: "Data/Orders/FailedToLoadOrder",
                orderNumber: props.parameter.orderNumber,
                status: 404,
            });
            return false;
        }
        throw error;
    }
});